import React from "react";
import "../style/spinner.css"; // Add your CSS file for styling the spinner

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
